/** Приглашение на официальный сервер «Кличат» — бессрочное, создано при сборке сервера 22.09.2026. */
export const OFFICIAL_INVITE = 'hhcWyvFj'

/** Публичные адреса Кличата: канал, поддержка, почта. Одно место, чтобы не расходились по экранам. */
export const LINKS = {
  site: 'https://klichat.ru',
  /** Канал с новостями и обновлениями. */
  telegramChannel: 'https://t.me/klichating',
  /** Поддержка: живой человек в Telegram, отвечает в рабочее время. */
  support: 'https://t.me/klichat_support',
  supportEmail: 'hello@klichat.ru',
  /** Сообщения об уязвимостях. */
  securityEmail: 'security@klichat.ru',
  /** Документация API для ботов. */
  docs: 'https://klichat.ru/docs',
  /** Официальный сервер: новости, вопросы, идеи, голосовой канал поддержки. */
  officialServer: `https://klichat.ru/invite/${OFFICIAL_INVITE}`,
} as const
